import React, { createElement } from "react";
import { render, createPortal } from "react-dom";
import BaseMessage, { Types } from './message'

const isVitrualDom = options => typeof options === 'object' && 'ref' in options && 'type' in options

function initOptions(options) {
  if (typeof options === 'string' || isVitrualDom(options)) {
    return {
      msg: options
    }
  } else if (typeof options !== 'object' || (typeof options.msg !== 'string' && !isVitrualDom(options.msg))) {
    console.error('The options is invalid! Please check it!')
    return {
      msg: 'Unknown error',
    }
  }

  return options
}

/* 
 * how to use:
 *
 * Type info、success、error、warn:
 ** Message.success('Send successfully')
 ** Message.error('Send failed')
 * 
 * Type loading: 
 ** const close = Message.loading('this is loading')
 ** new Promise(resole => setTimeout(resolve, 3000)) // after request(or others), proactive close 
 ** close()
*/

const distance = 6
let id = 0

const Message = (options) => {
  const _options = initOptions(options)
  if (id > 0) {
    // prevent same messsage repeat show
    const lastMessage = document.querySelector(`#_message${id - 1}`)
    if (lastMessage) {
      const lastText = lastMessage.innerText
      if (lastText === _options.msg) {
        return
      }
      if (typeof _options.msg === 'object') {
        try {
          const { props: { children } } = _options.msg
          if (children.length && children.filter((item) => item === lastText).length) {
            return
          }
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
  _options.id = `_message${id}`
  let wrapper = document.querySelector('#messageWrapper')
  const div = document.createElement('div');
  const moveWrapper = _options.moveWrapper = () => {
    const id = +_options.id.replace('_message', '')
    wrapper.style.marginTop = `${(parseInt(wrapper.style.marginTop) || - id * (48+6)) - (parseInt(div.style.height) || 48) - distance}px`
  }
  const close = _options.close = () => {
    _options.type === 'loading' && moveWrapper()
    render(null, div);
  }
  if (!wrapper) {
    wrapper = document.createElement('div');
    let style = 'position: fixed; top: 24px; left: 0; right: 0; z-index: 1500;'
    style += 'display: flex; align-items: center; flex-direction: column;';
    style += 'transition: margin-top .3s ease-out 0s;';
    wrapper.style  = style
    wrapper.id = 'messageWrapper'
    document.body.appendChild(wrapper)
  }
  div.style = `margin-bottom: ${distance}px;`
  div.id = _options.id
  wrapper.appendChild(div)
  render(<BaseMessage {..._options} />, div)
  // loading type how to setOpen when close?
  id++
  return close
}

Types.forEach((type) => {
  Message[type] = (options) => {
    const _options = initOptions(options)
    return Message({
      ..._options,
      type,
    })
  }
})

export default Message